import React from 'react';
import s from './PromoMessage.scss';

type CommonProps = {
  className?: string;
  clearancePromoMessage?: string;
  onSale?: boolean;
  promoMessage?: string | PromoMessageArrayProps[];
};

type IsEnsemble = {
  isEnsemble: true;
  productId: string;
};

type IsNotEnsemble = {
  isEnsemble?: false;
  productId?: never;
};

export type PromoMessageProps = CommonProps & (IsEnsemble | IsNotEnsemble);

type DefaultPromoMessageProps = {
  className?: string;
  promoMessage?: string;
};

const DefaultPromoMessage = ({
  className,
  promoMessage,
}: DefaultPromoMessageProps) => {
  return (
    <p className={className}>
      <span className={s.promoMessage}>{promoMessage}</span>
    </p>
  );
};

const PromoMessage = ({
  className,
  clearancePromoMessage,
  isEnsemble = false,
  onSale = false,
  productId,
  promoMessage,
}: PromoMessageProps) => {
  const isPromoArray = Array.isArray(promoMessage);
  const isPromoString = typeof promoMessage === 'string';

  if (onSale && clearancePromoMessage) {
    return (
      <DefaultPromoMessage
        className={className}
        promoMessage={clearancePromoMessage}
      />
    );
  }

  if (isPromoArray) {
    const promoArrayLength = promoMessage.length;
    const firstItem = promoMessage?.[0].item;
    const secondItem = promoMessage?.[1]?.item;
    const firstItemMsg = promoMessage?.[0].promoMessage;
    const isValidFirst2ItemsPromo = !!firstItem && !!secondItem;

    if (
      promoArrayLength === 1 ||
      (promoArrayLength === 2 && !isValidFirst2ItemsPromo)
    ) {
      return (
        <DefaultPromoMessage
          className={className}
          promoMessage={firstItemMsg}
        />
      );
    }

    if (promoArrayLength >= 2 && isValidFirst2ItemsPromo) {
      if (isEnsemble) {
        return (
          <div>
            {promoMessage.map((message) => {
              const { item: promoItem, promoMessage } = message;
              return (
                <p className={className} key={`${productId}-${promoItem}`}>
                  <span className={s.promoMessageTitle}>{`${promoItem}:`}</span>
                  <span className={s.promoMessage}>{promoMessage}</span>
                </p>
              );
            })}
          </div>
        );
      }
      return (
        <DefaultPromoMessage
          className={className}
          promoMessage={firstItemMsg}
        />
      );
    }
  }

  if (isPromoString) {
    return (
      <DefaultPromoMessage className={className} promoMessage={promoMessage} />
    );
  }

  return null;
};

export default PromoMessage;
